export class ApiError {
  constructor(public code: string) {}
}
